<template>
  <div id="app" class="flex flex-col-reverse w-full overflow-hidden text-sm h-dvh print:overflow-visible md:flex-col">
    <NavbarLayout v-if="hasLandInsightAccess" :activeRoute="$route.name" class="z-25 print:hidden" />
    <router-view />
  </div>
</template>

<script>
import { NavbarLayout } from "react-migration/layouts/nav/NavbarLayout";
import { bootIntercomDeferred } from "util/intercom";
import { ENVIRONMENT } from "util/environment";
import { startOnlineStatusPolling } from "./stores/onlineStatus/actions";
import Feature from "./stores/user/Feature";
import hasBetaFeature from "./stores/user/actions/hasBetaFeature";
import hasFeature from "./stores/user/actions/hasFeature";
import { setupMonitoring } from "./util/monitoring/window";
import { getDeviceSpecifications } from "./util/device_specifications";

/* eslint-disable no-undef */
export default {
  valtio: {
    state: {
      userStore: ["user"],
    },
  },
  components: {
    NavbarLayout,
  },
  computed: {
    hasLandInsightAccess() {
      return hasFeature(Feature.landInsightAccess);
    },
  },
  pusher: {
    "client-logout"(eventData) {
      if (this.user && eventData.userId === this.user._id) {
        const redirect = new URL(ENVIRONMENT.LOGOUT_URL);
        redirect.searchParams.set(
          error,
          `You were logged out by a LandTech admin. Please check your emails for details.`
        );
        window.location.href = redirect.toString();
      }
    },
  },
  watch: {
    user(newUser) {
      if (newUser) {
        startOnlineStatusPolling();

        const { _id, intercom_hash, firstname, surname, email, telephone, licence_summary, organisation_name } =
          this.user;

        intercom_hash &&
          !window.Cypress &&
          bootIntercomDeferred({
            app_id: ENVIRONMENT.INTERCOM_APP_ID,
            hide_default_launcher: true,
            user_id: _id,
            user_hash: intercom_hash,
            name: [firstname, surname].join(" "),
            email,
            phone: telephone,
            licence_summary,
            org: organisation_name,
          });

        // Datadog RUM might be related to performance problems we've been having again
        // https://landtech.slack.com/archives/C042BH9RFFU/p1678897186767419
        if (!hasBetaFeature(Feature.disableDatadogRum)) {
          setupMonitoring({
            applicationId: ENVIRONMENT.DATADOG_APPLICATION_ID,
            clientToken: ENVIRONMENT.DATADOG_CLIENT_TOKEN,
            service: ENVIRONMENT.DATADOG_SERVICE_NAME,
            site: ENVIRONMENT.DATADOG_SITE,
            release: ENVIRONMENT.APP_VERSION,
            environment:
              ENVIRONMENT.APP_ENV === "staging" && /preview/.test(ENVIRONMENT.API_URL || "")
                ? "pr"
                : ENVIRONMENT.APP_ENV,
            deviceSpecifications: getDeviceSpecifications(),
          });
        }
      }
    },
  },
};
</script>

<style>
@import "@landtechnologies/icons/font/lt-icons.css";
</style>
